import React from 'react'

const Location = () => {
  return (
    <div style={{height:'400px'}}>

<iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3560.009275786261!2d81.00071157543694!3d26.83965727669084!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjbCsDUwJzIyLjgiTiA4McKwMDAnMTEuOCJF!5e0!3m2!1sen!2sin!4v1699604344911!5m2!1sen!2sin" style={{width:'100%',height:'400px'}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

    </div>
  )
}

export default Location